import { useMemo } from 'react'
import { withTheme } from 'emotion-theming'
import styled from '@emotion/styled'
import PropTypes from 'prop-types'
import { withTranslation } from 'server/i18n'
import Button from '../Button'

import style from './BoatInfoHeader.style'

const BoatInfoHeaderStyled = styled.div(props => ({ ...style(props) }))

const BoatInfoHeader = ({ t, price, currency, condition, conditionCrm, year, length, vat, accomodation, boatID }) => {
    let vatTranslation = ''

    const trueCondition = useMemo(() => {
        if (conditionCrm) {
            if (conditionCrm === 'Stock') return 'new-stock'
        }
        return condition
    }, [condition, conditionCrm])

    switch (vat) {
        case 'Yes':
            vatTranslation = 'vat-yes'
            break
        default:
            vatTranslation = 'vat-no'
    }

    return (
        <BoatInfoHeaderStyled>
            <div className="BoatPrice">
                <div className="price">
                    {+price === 0 ? '' : currency} {+price === 0 ? t('price-upon-request') : price}
                    <Button
                        variation="tertiary"
                        dataAttrs={{
                            'gtm-event': 'link',
                            'gtm-label': 'Enquire',
                            'gtm-action': 'Enquire',
                            'gtm-category': 'Enquire'
                        }}
                        link={`/inquiry?boatID=${boatID}&type=buy`}>
                        {t('send-inquiry')}
                    </Button>
                </div>

                {vatTranslation && +price !== 0 && <span className="vat">{t(vatTranslation)}</span>}
                {trueCondition === 'New' && +price !== 0 ? (
                    <span>
                        <br />
                        {t('controls:standard-spec-price')}
                    </span>
                ) : (
                    ''
                )}
            </div>

            <ul className="FeaturesList">
                <li>
                    <span>{t('condition')}</span> {t(`controls:${trueCondition}`)}
                </li>
                {year && year !== 'NO_DATA' && (
                    <li>
                        <span>{t('year')}</span> {year}
                    </li>
                )}
                <li>
                    <span>{t('length')}</span> {length}
                </li>
                {accomodation && accomodation !== 'NO_DATA' && (
                    <li>
                        <span>{t('accomodation')}</span> {length}
                    </li>
                )}
            </ul>
        </BoatInfoHeaderStyled>
    )
}

BoatInfoHeader.propTypes = {
    t: PropTypes.func.isRequired,
    condition: PropTypes.string.isRequired,
    conditionCrm: PropTypes.string.isRequired,
    year: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    length: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    price: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    currency: PropTypes.string,
    vat: PropTypes.string.isRequired,
    accomodation: PropTypes.string,
    boatID: PropTypes.string
}

BoatInfoHeader.defaultProps = {
    year: null,
    currency: 'EUR',
    accomodation: null,
    boatID: null
}

export default withTranslation('common', 'controls')(withTheme(BoatInfoHeader))
